const Breakpoints = Object.freeze({
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    lgx: 1024,
    xl: 1200,
    xxl: 1400,
    xxxl: 1600,
});